// extracted by mini-css-extract-plugin
export default {"scrollBar":"group-aside_scrollBar__eokOX","textAreaScroll":"group-aside_textAreaScroll__fUcfA","groupDetailAside":"group-aside_groupDetailAside__mWniM group-aside_scrollBar__eokOX"};